import { Ref } from 'vue';
import { useCloudApi } from '@/components/Cloud/Hooks/useCloudApi.js';
import { CloudService } from '@/services/api/integration.service';
import { useRoute } from 'vue-router';
import { AwsServiceInfo } from '@/components/Cloud/Hooks/cloud.all.types';

interface RespType {
  isLoading: Ref<boolean>;
  data: Ref<unknown>;
  error: Ref<null>;
  makeAPICall: (params: any) => Promise<void>;
}

export function useAwsServiceDetails() {
  const { params } = useRoute();

  const { isLoading, data, error, makeAPICall }: RespType = useCloudApi(
    CloudService.getServicesInfo,
    (resp) => {
      return {
        meta: resp.data.service?.meta,
        pullFrequency: resp.data.service?.pullFrequencyMins.toString(),
        enableMonitoring: resp.data.service?.isMonitoringEnabled === 1,
        global:
          resp.data.service?.pullFrequencyMins ===
          resp.data.service?.globalPullFrequencyMins,
        tagsCondition: resp.data.service?.tagsCondition,
        globalPullFrequencyMins:
          resp.data.service?.globalPullFrequencyMins.toString(),
        tags:
          resp.data.service?.tags.length > 0
            ? [...JSON.parse(JSON.stringify(resp.data.service?.tags)), {}]
            : [{}],
      };
    },
  );

  const fetchAwsServiceDetails = (service) => {
    makeAPICall({
      subscriptionId: params.subscriptionId,
      service,
    });
  };

  return {
    isLoading,
    data: data as Ref<AwsServiceInfo>,
    error,
    fetchAwsServiceDetails,
  };
}
